import React from 'react';
import moment from 'moment';
import { MaskRestrictedText } from '_src/components';

export default [
  {
    title: 'Name',
    dataIndex: 'studentFullName',
    sorter: true,
    render: (_, { studentFullName }) => studentFullName
  },
  {
    title: 'Primary Pay Type',
    dataIndex: 'sponsor',
    render: _ => <MaskRestrictedText text={_} />
  },
  {
    title: 'DL#',
    dataIndex: 'driversLicenseNumber',
    render: _ => <MaskRestrictedText text={_} />
  },
  {
    title: 'Class A or B',
    dataIndex: 'cdlClass'
  }
];
